import { useState } from "react";
import { useColorTheme } from "context/ColorThemeContext";
import { Box, Typography, TextField, InputAdornment, IconButton, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from "prop-types";
import AddCategory from "./AddCategory";

function SearchCategoryManager({ clickSearch, setSearchData, searchData, refreshDataAfterChange }) {
  const colors = useColorTheme();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [selectedItem] = useState(null);
  const handleChange = (e) => {
    setSearchData((prev) => ({ ...prev, name: e.target.value }));
  };

  return (
    <Box sx={{ mb: 3 }}>
      {/* Tiêu đề */}
      <Typography fontWeight="bold" fontSize="24px">
        DANH SÁCH DANH MỤC
      </Typography>
      <Typography fontSize="16px">Quản lý danh mục sản phẩm</Typography>

      {/* Hàng 1: nút Thêm mới */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: 2,
          mb: 2,
        }}
      >
        <Button
          variant="contained"
          onClick={() => setIsAddOpen(true)}
          sx={{
            backgroundColor: colors.buttonBackground || "#2196F3",
            color: colors.popupText || "white",
            textTransform: "none",
          }}
          startIcon={<AddIcon />}
        >
          Thêm mới
        </Button>
      </Box>

      {/* Hàng 2: Tìm kiếm và các nút Filter, Sort */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        {/* Ô tìm kiếm bên trái */}
        <TextField
          placeholder="Tìm kiếm"
          size="small"
          variant="outlined"
          value={searchData.name || ""}
          onChange={handleChange}
          onKeyDown={(e) => e.key === "Enter" && clickSearch()}
          InputProps={{
            sx: {
              backgroundColor: "#f1f7ff",
              borderRadius: "8px",
              width: "250px",
              height: "45px !important",
              "& fieldset": { border: "none" },
            },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={clickSearch}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* Nút Filter + Sort bên phải */}
        <Box display="flex" alignItems="center" gap={1}>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              textTransform: "none",
              borderColor: "#E1E3E9",
              color: "#3F4254",
            }}
            startIcon={<FilterListIcon />}
          >
            Filter
          </Button>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              textTransform: "none",
              borderColor: "#E1E3E9",
              color: "#3F4254",
            }}
            startIcon={<SortIcon />}
          >
            Sort
          </Button>
        </Box>
      </Box>
      <AddCategory
        open={isAddOpen}
        onClose={() => setIsAddOpen(false)}
        editMode={!!selectedItem}
        initialData={selectedItem}
        refreshDataAfterChange={refreshDataAfterChange}
      />
    </Box>
  );
}

SearchCategoryManager.propTypes = {
  clickSearch: PropTypes.func.isRequired,
  setSearchData: PropTypes.func.isRequired,
  searchData: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  refreshDataAfterChange: PropTypes.func.isRequired,
};

export default SearchCategoryManager;
